import template from './annualReviewMonthModal.html';
import controller from './annualReviewMonthModalCtrl';
import './style.scss';

export default {
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    modalInstance: '<',
    familyId: '<',
  },
};
